exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preliminary-questions-container{min-height:80%;position:relative;width:100%;background:#fff;position:absolute;top:100px;bottom:0;left:0;right:0;display:flex;flex-direction:column}@media(max-width:992px){.preliminary-questions-container{top:60px}}.preliminary-questions-container .content{width:70%;height:100%;margin:0 auto;display:flex;flex-direction:column;position:relative}@media(max-width:992px){.preliminary-questions-container .content{width:80%}}.preliminary-questions-container .content .errors{color:#d06f6e;text-align:center;font-weight:500}", ""]);

// exports
